(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('rightMenu', ["path", "routeHelper", "modulesManager", "feature", "troubleshooting", "sideMenuManager", "$timeout", function (path, routeHelper, modulesManager, feature, troubleshooting, sideMenuManager, $timeout) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('right-menu').template(),
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.$watch(function () {
                    return sideMenuManager.rightMenuVisible() && sideMenuManager.activeMenu();
                }, function (menu) {
                    var newMenus = menu && menu.submenus || [];
                    if (newMenus.length) {
                        $scope.menus = newMenus;
                    }
                });
            }
        };
    }]);
}());